import axios from 'axios'
import { useProfile } from '@/composable/useProfile'

const { getToken, isSignedIn, signOut, getCurrentProject } = useProfile()

export interface ExportParams {
  name: string
  sheets: Sheet[]
}

export interface Sheet {
  name: string
  data: unknown[]
}

export const exportExcel = async ({
  name,
  sheets,
}: ExportParams): Promise<void> => {
  const filename = `${name}.xlsx`
  try {
    const isDev = localStorage.getItem('isAvikDev') === 'true'
    const headers: Record<string, string> = {
      'reges-avik-project': getCurrentProject()?.name || '',
      Authorization: `Bearer ${getToken()}`,
      'x-stage': isDev ? 'prelive' : 'production',
    }

    const resp = await axios({
      url: 'https://sj-avik-backend.reges-services.se/spreadsheet-generator/xlsx',
      method: 'POST',
      responseType: 'arraybuffer',
      headers,
      data: {
        name,
        sheets,
      },
    })

    const a = document.createElement('a')
    const url = window.URL.createObjectURL(
      new Blob([resp.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
    )
    a.href = url
    a.target = '_blank'
    a.download = filename
    document.body.appendChild(a)
    a.click()
  } catch (err) {
    console.dir(err)
  }
}
